import DOMPurify from 'dompurify';
import katex from 'katex';

/**
 * Re-renders each Quill formula (.ql-formula) into an HTML string,
 * using the original LaTeX saved in data-value and replacing the saved KaTeX markup.
 *
 * The data-value contains the clean LaTeX, so
 * regenerating from there produces valid KaTeX again.
 *
 * @param {string} html - Saved HTML that can contain .ql-formula nodes
 * @returns {string} HTML with each formula re-rendered from its LaTeX
 */
const reRenderFormulas = (html) => {
  if (!html) return html;

  try {
    const doc = new DOMParser().parseFromString(html, 'text/html');

    doc.querySelectorAll('.ql-formula').forEach((node) => {
      const latex = node.getAttribute('data-value');
      if (!latex) return; // Without a source to regenerate, leave it as is

      try {
        node.innerHTML = katex.renderToString(latex, { throwOnError: false });
      } catch (e) {
        // A bad formula shouldn't break the entire preview
      }
    });

    return doc.body.innerHTML;
  } catch (e) {
    return html; // If the parsing fails, return the original HTML
  }
};

/**
 * Regenerates formulas from your LaTeX and sanitizes the result.
 *
 * @param {string} html - Saved rich-text HTML (may contain .ql-formula)
 * @returns {string} HTML with regenerated and sanitized formulas
 */
export const sanitizeRichText = (html) =>
  DOMPurify.sanitize(reRenderFormulas(html));
